import React from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import debounce from "debounce-promise";
import {withRouter} from "react-router-dom";
import {getCatId} from "./utils";
import { 
  getPrivateSearchEnabled, 
  setPrivateSearchEnabled, 
  handlePrivateSearchToggle,
  getAuthStatus
} from "./auth";
import './PrivateSearch.css';

class SearchBar extends React.Component {

  state =  { 
    inputValue: '' , 
    queryString: '',
    selectedOptions: [],
    privateSearchEnabled: getPrivateSearchEnabled(),
    isAuthenticated: getAuthStatus()
  };
    stateRef = React.createRef()
    asyncSelectRef = React.createRef()

    // Convert space-separated tags string to AsyncCreatableSelect format (array of {value, label} objects)
    // Note: tagsString is already decoded (comes from TagSearch.tagButtonTexts), so no need to decodeURIComponent
    parseTagsToOptions = (tagsString) => {
      if (!tagsString || tagsString === 'null' || tagsString.trim() === '') {
        return [];
      }
      const tagArray = tagsString.split(' ').filter(tag => tag.trim() !== '');
      return tagArray.map(tag => ({
        value: tag,
        label: tag
      }));
    }

    componentDidMount() {
        // Refresh auth state from localStorage on component mount
        // This ensures checkbox state updates after OAuth success
        this.setState({
            privateSearchEnabled: getPrivateSearchEnabled(),
            isAuthenticated: getAuthStatus()
        });
        
        // Initialize with current tags if provided
        if (this.props.currentTags) {
          const selectedOptions = this.parseTagsToOptions(this.props.currentTags);
          const queryString = selectedOptions.map(v => v.value).join(' ');
          this.setState({
            selectedOptions: selectedOptions,
            queryString: queryString
          });
        }
    }

    componentWillReceiveProps(nextProps,context) {
        if (nextProps.cat !== this.props.cat) {
            //console.log(`nextProps.cat: ${nextProps.cat} vs this.props.cat: ${this.props.cat}`)
        }
        
        // Note: No need to handle currentTags prop changes here because:
        // - TagSearch uses key={window.location.href}, so it remounts on URL changes
        // - When TagSearch remounts, SearchBar also remounts, so componentDidMount handles it
        
        if (this.asyncSelectRef.current) {
          this.asyncSelectRef.current.focus()
        }
        // this.asyncSelectRef.current.loadOptions = this.debouncedLoadOptions
    }

   fetchOptions = (inputValue, cat) => {
      if (!inputValue){
          // if no input at all, current no suggestion
          return null
      }
       let catId = getCatId(cat)
       //console.log(`Fetching ${cat} tags based on prefix`)
      let apiUrl = `https://${window.location.host}/api/tags/?size=20&cat=${catId}&prefix=${inputValue}`
      //console.log(`apiUrl: ${apiUrl}`)
      var res = [];
      return fetch(apiUrl)
          .then(response => response.json())
          .then(data => {
          var suggestion = data['results'];
          //console.log(suggestion);
          //console.log(suggestion.length);
          for(var i = 0; i < suggestion.length; i++){
              var dict = {};
              dict['value'] = suggestion[i]['name'];
              dict['label'] = suggestion[i]['name'];
              dict['count'] = suggestion[i]['count'];
              res.push(dict);
          }
          //console.log(res);
          return res;
      })
};

 promiseOptions = (inputValue, cat) =>
  new Promise((resolve) => {
      resolve(this.fetchOptions(inputValue, cat));
  });

 debouncedLoadOptions = debounce((searchTerm, callback) => {
    return this.promiseOptions(searchTerm, this.stateRef.current)
}, 250, {trailing: true})

  handleChange = (e) => {
      var tags = []
      const selectedOptions = e || [];
      for(var i = 0; i < selectedOptions.length; i++){
          //console.log(selectedOptions[i]['value'])
          tags.push(selectedOptions[i]['value'])
      }
      let queryString = tags.join(' ')
      //console.log(queryString)
      this.setState({
        queryString: queryString,
        selectedOptions: selectedOptions
      })
      //https://stackoverflow.com/questions/30782948/why-does-calling-react-setstate-method-not-mutate-the-state-immediately
      //console.log(this.state.queryString)
  }
  handleSubmit = (e) => {
      //console.log(this.state.queryString)
      // URL no longer includes user_collection parameter - checkbox state (localStorage) is the single source of truth
      let url = '/'+this.stateRef.current+'/tags/?q='+this.state.queryString;
      
      this.props.history.push(url);
  }

  handlePrivateSearchToggle = (event) => {
    const enabled = event.target.checked;
    
    if (enabled) {
      const success = handlePrivateSearchToggle(true);
      if (success) {
        this.setState({ 
          privateSearchEnabled: true,
          isAuthenticated: true 
        });
      }
    } else {
      setPrivateSearchEnabled(false);
      this.setState({ privateSearchEnabled: false });
    }
  }

  showToast = (message) => {
    const toast = document.createElement('div');
    toast.className = 'sync-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.classList.add('show');
    }, 10);
    
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 2000);
  }

  handleSync = async () => {
    if (!this.state.isAuthenticated) {
      return;
    }

    // Get current category and convert to subject_type
    const currentCat = this.props.cat;
    const subjectType = getCatId(currentCat);
    
    // Validate subject type
    const validSubjectTypes = [1, 2, 3, 4, 6];
    if (!subjectType || !validSubjectTypes.includes(subjectType)) {
      this.showToast('无效的主题类型');
      return;
    }

    try {
      const response = await fetch(
        `https://${window.location.host}/api/usercollections/sync/?subject_type=${subjectType}`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 401) {
        this.showToast('请先授权登录');
      } else if (response.status === 429) {
        this.showToast('每小时每个类别只能同步一次');
      } else if (response.ok) {
        const data = await response.json();
        this.showToast(`同步已开始: ${data.message || '同步中...'}`);
      } else {
        this.showToast('同步失败');
      }
    } catch (error) {
      console.error('Sync failed:', error);
      this.showToast('同步失败: ' + error.message);
    }
  }
  render() {
    //console.log(`this.props.cat: ${this.props.cat}`)
      this.stateRef.current = this.props.cat
      //console.log(`this.stateRef.current :${this.stateRef.current}`)
    return (
    <div>
    {/*<div hidden={true}>{this.props.cat}</div>*/}
    <form id="tagSearch" name="tagSearch" onSubmit={this.handleSubmit} method="GET">
      <AsyncCreatableSelect
        className='my-react-select-container'
        classNamePrefix="my-react-select"
        placeholder="输入标签，自动补全，可多标签"
        autoFocus
        isMulti
        //have multi search category, cache options will lead to wrong suggestions
        cacheOptions={false}
        defaultOptions
        loadOptions={this.debouncedLoadOptions}
        onChange={this.handleChange}
        value={this.state.selectedOptions}
        ref={this.asyncSelectRef}
      />
    </form>
    
    {/* Search button and checkbox on same line */}
    <div className="search-row">
      <input type="submit" value="搜索" className="btnPink" form="tagSearch"/>
      <div className="private-search-toggle">
        <label>
          <input
            type="checkbox"
            checked={this.state.privateSearchEnabled}
            onChange={this.handlePrivateSearchToggle}
          />
          <span>
            {this.state.privateSearchEnabled && this.state.isAuthenticated 
              ? '仅自己可见' 
              : '仅自己可见'}
          </span>
        </label>
        {this.state.privateSearchEnabled && !this.state.isAuthenticated && (
          <span className="auth-notice">
            (需要授权)
          </span>
        )}
        {this.state.isAuthenticated && (
          <button 
            className="sync-button" 
            onClick={this.handleSync}
            title="同步收藏"
          >
            ↻
          </button>
        )}
      </div>
    </div>
    </div>
    );
  }
}
export default withRouter(SearchBar)